"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M11 17.33V20h2v-2.67l-1-1zm2-10.66V4h-2v2.67l1 1zM16.33 12l1 1H20v-2h-2.67zM4 11v2h2.67l1-1-1-1z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M2 9v6h5.5l3-3-3-3zm4.67 4H4v-2h2.67l1 1zM22 9h-5.5l-3 3 3 3H22zm-2 4h-2.67l-1-1 1-1H20zm-5 3.5-3-3-3 3V22h6zM13 20h-2v-2.67l1-1 1 1zM9 7.5l3 3 3-3V2H9zM11 4h2v2.67l-1 1-1-1z"
}, "1")], 'GamesTwoTone');